import WhereWeWorkComponent from "../../components/about/where-we-work";

const WhereWeWorkPage = () => <WhereWeWorkComponent />

export default WhereWeWorkPage;